// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PatientGroups-__styles__container--1MsgY","main":"src-components-PatientGroups-__styles__main--2Qmmx","menu":"src-components-PatientGroups-__styles__menu--2AHMX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientGroups/styles.css
// module id = 1992
// module chunks = 0